import { AtCompanyAccountDTO } from "../at-company-account/at-company-account-dto";
import { CompanyLegalEntityRef } from "../company-accounts/company-legal-entities/company-legal-entity-ref";

export class AtLegalEntityDTO extends AtCompanyAccountDTO {
  legalEntity: CompanyLegalEntityRef | null = null;
}
